import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './Singleeventdetails.css';

import Subscribe from '../components/Subscribe';
import Ticket from '../assets/images/ticket.png';
import Banner from '../assets/images/banner.png';
import sunIcon from '../assets/images/Sun.png';
import compassIcon from '../assets/images/campuse.png';
import groupIcon from '../assets/images/compass.png';
import peopleIcon from '../assets/images/people.png';
import leafIcon from '../assets/images/wing.png';
import Reviews from '../components/Reviews';
import { api } from '../services/api';
import { useAuth } from '../context/AuthContext';
import asif from '../assets/images/asifkhan.png';
import devansh from '../assets/images/DevanshSharma.png';
import Gurmeetsingh from '../assets/images/Gurmeetsingh.png';
import Harmanpreet from '../assets/images/HarmanpreetSingh.png';
import Himanshi from '../assets/images/HimanshiNegi.png';
import JatinBansal from '../assets/images/JatinBansal.png';
import Karan from '../assets/images/Karan.png';
import JatindraSingh from '../assets/images/JatindraSingh.png';
import Karanveer from '../assets/images/KaranveerSingh.png';
import KritikaRanta from '../assets/images/KritikaRanta.png';
import Rahil from '../assets/images/RahilSahni.png';
import Ritika from '../assets/images/RitikaSharma.png';
import Savi from '../assets/images/SaviBali.png';
import Shivani from '../assets/images/ShivaniSingh.png';
import VarunSharma from '../assets/images/VarunSharma.png';

import Ankita from '../assets/images/AnkitaMittal.png';
import Kiran from '../assets/images/KiranKaur.png';
import Priyanka from '../assets/images/PriyankaSharma.png';
import Sagar from '../assets/images/SagarSingh.png';
import Vishal from '../assets/images/VishalSharma.png';

import Sonia from '../assets/images/SoniaPundir.png';
import Arpan from '../assets/images/ArpanThapa.png';
import Mansi from '../assets/images/MansiVerma.png';
import Sonali from '../assets/images/SonaliSharma.png';
import Shalini from '../assets/images/Shalini.png';

import RazorpayLogo from '../assets/images/razarpay.png';




const attendeeData = [
  {
    name: 'Sonia Pundir',
    image: Sonia,
  },
  {
    name: 'Arpan Thapa',
    image: Arpan,
  },
  {
    name: 'Mansi Verma',
    image: Mansi,
  },
  {
    name: 'Sonali Sharma',
    image: Sonali,
  },
  {
    name: 'Shalini',
    image: Shalini,
  },
  {
    name: 'Ankita Mittal',
    image: Ankita,
  },
  {
    name: 'Kiran Kaur',
    image: Kiran,
  },
  {
    name: 'Priyanka Sharma',
    image: Priyanka,
  },
  {
    name: 'Sagar Singh',
    image: Sagar,
  },
  {
    name: 'Vishal Sharma',
    image: Vishal,
  },
  {
    name: 'Asif Khan',
    image: asif,
  },
  {
    name: 'Devansh Sharma',
    image: devansh,
  },
  {
    name: 'Gurmeet Singh',
    image: Gurmeetsingh,
  },
  {
    name: 'Harmanpreet Singh',
    image: Harmanpreet,
  },
  {
    name: 'Himanshi Negi',
    image: Himanshi,
  },
  {
    name: 'Jatin Bansal',
    image: JatinBansal,
  },
  {
    name: 'Karan',
    image: Karan,
  },
  {
    name: 'Jatindra Singh',
    image: JatindraSingh,
  },
  {
    name: 'Karanveer Singh',
    image: Karanveer,
  },
  {
    name: 'Himanshi Negi',
    image: Himanshi,
  },
  {
    name: 'Kritika Ranta',
    image: KritikaRanta,
  },
  {
    name: 'Rahil Sahni',
    image: Rahil,
  },
  {
    name: 'Ritika Sharma',
    image: Ritika,
  }, {
    name: 'Savi Bali',
    image: Savi,
  },
  {
    name: 'Shivani Singh',
    image: Shivani,
  },
  {
    name: 'Varun Sharma',
    image: VarunSharma,
  }
];

const Singleeventdetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [eventData, setEventData] = useState(null);
  const [selectedTicket, setSelectedTicket] = useState('female');
  const [showGuestForm, setShowGuestForm] = useState(false);
  const [registeredUsers, setRegisteredUsers] = useState(null);
  const [guestData, setGuestData] = useState({
    fullName: '',
    email: '',
    phone: ''
  });
  const [isCreatingOrder, setIsCreatingOrder] = useState(false);
  const [orderError, setOrderError] = useState('');
  const [orderSuccess, setOrderSuccess] = useState('');
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState('');
  const [isAboutExpanded, setIsAboutExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [couponCode, setCouponCode] = useState('');
  const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);
  const [couponError, setCouponError] = useState('');
  const [couponSuccess, setCouponSuccess] = useState('');
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponFinalAmount, setCouponFinalAmount] = useState(null);
  const [eventCoupon, setEventCoupon] = useState(null);

  const getStoredUser = () => {
    const raw = localStorage.getItem('user');
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  };

  useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  useEffect(() => {
    let isMounted = true;
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const normalizeThumbnail = (url) => {
      if (!url) return '';
      return url.replace(/^https?:\/\/localhost(:\d+)?/i, API_BASE_URL);
    };

    const normalizeProfilePicture = (url) => {
      if (!url) return '';
      return url.replace(/^https?:\/\/localhost(:\d+)?/i, API_BASE_URL);
    };

    const loadEvent = async () => {
      if (!id) return;
      try {
        const response = await fetch(`${API_BASE_URL}/api/v1/public/event/${id}`);
        const data = await response.json();
    console.log("event data", data);
        if (!response.ok) {
          throw new Error(data.message || 'Failed to load event');
        }
        const eventDateForTitle = data?.event?.date 
  ? new Date(data.event.date).toLocaleDateString('en-US', { 
      day: 'numeric', 
      month: 'long', 
      year: 'numeric' 
    })
  : '';
       document.title = data?.event?.title ? `${data.event.title} | ${eventDateForTitle} | ${data.event.city}` : 'Event Details • The Event House';
        const selected = data?.event;
        const usersFromResponse = Array.isArray(data?.registeredUsers?.users)
          ? data.registeredUsers.users
          : Array.isArray(data?.users)
            ? data.users
            : Array.isArray(selected?.users)
              ? selected.users
              : [];
        if (selected && isMounted) {
          setEventData({
            ...selected,
            normalizedThumbnail: normalizeThumbnail(selected.thumbnail),
            normalizedUsers: usersFromResponse.map((user) => ({
              ...user,
              normalizedProfilePicture: normalizeProfilePicture(user.profilePicture)
            }))
          });
        }
        if (isMounted) {
          const couponList = Array.isArray(data?.couponDetails)
            ? data.couponDetails
            : data?.couponDetails
              ? [data.couponDetails]
              : [];
              console.log("coupon list", couponList);
          setEventCoupon(couponList);
        }
        if (isMounted) {
          setRegisteredUsers(data?.registeredUsers || null);
        }
      } catch (error) {
        console.error('Failed to load event', error);
      }
    };

    loadEvent();

    return () => {
      isMounted = false;
    };
  }, [id]);

  useEffect(() => {
    const checkIsMobile = () => setIsMobile(window.innerWidth <= 600);
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  const loadRazorpayScript = () =>
    new Promise((resolve) => {
      if (window.Razorpay) {
        resolve(true);
        return;
      }
      const existingScript = document.querySelector('script[src="https://checkout.razorpay.com/v1/checkout.js"]');
      if (existingScript) {
        existingScript.addEventListener('load', () => resolve(true));
        existingScript.addEventListener('error', () => resolve(false));
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });

  const buildFullName = (user) => {
    if (!user) return '';
    if (user.fullName) return user.fullName;
    const parts = [user.firstName, user.lastName].filter(Boolean);
    return parts.join(' ');
  };

  const getGuestPrefill = (user) => ({
    fullName: buildFullName(user) || '',
    email: user?.email || '',
    phone: user?.phone || ''
  });

  const buildOrderPayload = (data) => {
    const payload = {
      email: data.email || '',
      phone: data.phone || '',
      fullName: data.fullName || '',
      eventId: id,
      gender: selectedTicket,
      quantity: 1
    };

    if (appliedCoupon?._id) {
      payload.couponDetails = {
        isCouponApplied: true,
        couponId: appliedCoupon._id
      };
    }

    return payload;
  };

  const startRazorpayCheckout = async (payload) => {
    setOrderError('');
    setOrderSuccess('');
    setShowErrorPopup(false);
    setErrorPopupMessage('');
    setIsCreatingOrder(true);

    try {
      const response = await api.createpaymentOrder(payload);
      const { order, key } = response || {};

      if (!order?.id || !key) {
        throw new Error('Unable to start payment. Missing order details.');
      }

      const loaded = await loadRazorpayScript();
      if (!loaded) {
        throw new Error('Failed to load Razorpay checkout.');
      }

      const razorpayImage = "https://eventhouse.in/Brown%20and%20Orange%20Event%20Management%20Logo.svg";
     
        console.log("razorpay image", razorpayImage)
      const options = {
        key,
        order_id: order.id,
        currency: order.currency || 'INR',
        // amount: order.amount ? order.amount * 100 : undefined,
        name: ' The Event House',
        image: razorpayImage,
        description: 'Event ticket purchase',
        prefill: {
          name: payload.fullName,
          email: payload.email,
          contact: payload.phone
        },
        notes: {
          eventId: payload.eventId,
          gender: payload.gender
        },
        handler: () => {
          setOrderSuccess('Payment initiated. You will receive confirmation shortly.');
          if (order?.dbOrderId) {
            navigate(`/Successticket/${order.dbOrderId}`);
          }
        },
        modal: {
          ondismiss: () => {
            setIsCreatingOrder(false);
          }
        }
      };



      const razorpay = new window.Razorpay(options);
      razorpay.on('payment.failed', (response) => {
        setOrderError(response?.error?.description || 'Payment failed. Please try again.');
      });
      razorpay.on('order.paid', (response) => {
        console.log("on order paid", response)
      });
      razorpay.open();
      return true;
    } catch (error) {
      const message = error.message || 'Unable to create payment order.';
      setOrderError(message);
      setErrorPopupMessage(message);
      setShowErrorPopup(true);
      return false;
    } finally {
      setIsCreatingOrder(false);
    }
  };

  const handleBuyNow = () => {
    if (!isTermsAccepted) return;
    setOrderError('');
    setOrderSuccess('');
    setShowErrorPopup(false);
    setErrorPopupMessage('');
    const token = localStorage.getItem('token');
    const storedUser = getStoredUser();
    if (!isAuthenticated || !token || !storedUser) {
      setGuestData({ fullName: ''});
      setShowGuestForm(true);
      return;
    }

    const prefill = getGuestPrefill(storedUser);
    if (!prefill.fullName || !prefill.email || !prefill.phone) {
      setGuestData(prefill);
      setShowGuestForm(true);
      return;
    }

    const payload = buildOrderPayload(prefill);
    startRazorpayCheckout(payload);
  };

  const handleGuestInputChange = (event) => {
    const { name, value } = event.target;
    if (name === 'phone') {
      const digitsOnly = value.replace(/\D/g, '').slice(0, 10);
      setGuestData((prev) => ({ ...prev, [name]: digitsOnly }));
      return;
    }
    setGuestData((prev) => ({ ...prev, [name]: value }));
  };

  const handleGuestSubmit = async (event) => {
    event.preventDefault();
    setOrderError('');
    setOrderSuccess('');
    setShowErrorPopup(false);
    setErrorPopupMessage('');

    if (!guestData.fullName || !guestData.email || !guestData.phone) {
      const message = 'Please fill out all required fields.';
      setOrderError(message);
      setErrorPopupMessage(message);
      setShowErrorPopup(true);
      return;
    }
    if (guestData.phone.length !== 10) {
      const message = 'Please enter a valid 10-digit mobile number.';
      setOrderError(message);
      setErrorPopupMessage(message);
      setShowErrorPopup(true);
      return;
    }

    const payload = buildOrderPayload(guestData);
    const success = await startRazorpayCheckout(payload);
    if (success) {
      setShowGuestForm(false);
    }
  };

  const fallbackDescription = "On 14th February, Mulaqat brings people together for an evening designed around real conversations and meaningful connections. Hosted in a relaxed, premium setting, this singles mixer focuses on comfort, presence, and shared moments without pressure or expectations. Whether you come curious or confident, the experience is thoughtfully curated to help conversations flow naturally and the evening unfold with ease.";
  const aboutShortDescription = eventData?.shortDescription || fallbackDescription;
  const aboutLongDescription = eventData?.description || fallbackDescription;
  const hasHtmlDescription = /<\/?[a-z][\s\S]*>/i.test(aboutLongDescription || '');
  const stripHtml = (value) => value.replace(/<[^>]*>/g, ' ');
  const fullAboutText = `${aboutShortDescription} ${hasHtmlDescription ? stripHtml(aboutLongDescription) : aboutLongDescription}`
    .replace(/\s+/g, ' ')
    .trim();
  const aboutWords = fullAboutText.split(/\s+/).filter(Boolean);
  const aboutTruncated = aboutWords.slice(0, 50).join(' ');
  const shouldTruncateAbout = isMobile && aboutWords.length > 50 && !isAboutExpanded;
  const aboutDisplayText = shouldTruncateAbout ? `${aboutTruncated}...` : fullAboutText;
  const longDescriptionLines = aboutLongDescription
    ? aboutLongDescription.split(/\r?\n/).map((line) => line.trim()).filter(Boolean)
    : [];
  const eventDateLabel = eventData?.date
    ? new Date(eventData.date).toLocaleString('en-US', { day: 'numeric', month: 'long', year: 'numeric' })
    : `${eventData?.date}`;
  console.log("dateevent",eventDateLabel);
  const eventTimeLabel = eventData?.time || '05:00 PM onwards';
  const eventLocationLabel = [ eventData?.venue, eventData?.city, eventData?.state, eventData?.country].filter(Boolean).join('  ')
    || 'Mosaic, CP 67, Mohali, Punjab, India';
  const bannerImage = eventData?.normalizedThumbnail || Banner;
  const femalePricing = eventData?.femalePrice || {};
  const malePricing = eventData?.malePrice || {};
  const selectedPricing = selectedTicket === 'female' ? femalePricing : malePricing;
  const ticketOriginalPrice = selectedPricing.price;
  const ticketDiscountedPrice = selectedPricing.discountedPrice;
  const baseTicketPrice =
    typeof ticketDiscountedPrice === 'number'
      ? ticketDiscountedPrice
      : typeof ticketOriginalPrice === 'number'
        ? ticketOriginalPrice
        : 0;
  const totalWithGst = Math.round(baseTicketPrice * 1.18);
  const finalPayableAmount =
    typeof couponFinalAmount === 'number' && appliedCoupon
      ? Math.round(couponFinalAmount)
      : totalWithGst;
  const couponSavings =
    typeof couponFinalAmount === 'number' && appliedCoupon
      ? Math.max(0, totalWithGst - Math.round(couponFinalAmount))
      : 0;
  const getDiscountPercent = (price, discountedPrice) => {
    if (typeof price !== 'number' || typeof discountedPrice !== 'number') return null;
    if (price <= 0 || discountedPrice >= price) return null;
    return Math.round(((price - discountedPrice) / price) * 100);
  };
  const femaleDiscountPercent = getDiscountPercent(femalePricing.price, femalePricing.discountedPrice);
  const maleDiscountPercent = getDiscountPercent(malePricing.price, malePricing.discountedPrice);
  const minage = eventData?.age?.minAge;
  const maxage = eventData?.age?.maxAge;
  const ageLabel =
    typeof minage === 'number' && typeof maxage === 'number'
      ? `${minage} - ${maxage}`
      : typeof minage === 'number'
        ? `${minage}+`
        : typeof maxage === 'number'
          ? `Up to ${maxage}`
          : 'All ages';
  const capacityValue = Number(eventData?.capacity) || 0;
  const femaleBooked = Number(eventData?.femaleCount);
  const maleBooked = Number(eventData?.maleCount);
  const maleLeftTickets = Math.max(0, capacityValue / 2 - maleBooked);
  const femaleLeftTickets = Math.max(0, capacityValue / 2 - femaleBooked);
  const shouldUseDummyAttendees = eventData?.showDummyUsers !== false;
  const apiAttendees = (eventData?.normalizedUsers || [])
    .filter((user) => user?.normalizedProfilePicture)
    .map((user) => ({
      name: buildFullName(user) || 'Guest',
      image: user.normalizedProfilePicture
    }));
  const attendeesToShow = shouldUseDummyAttendees ? attendeeData : apiAttendees;

  const resetCouponState = () => {
    setAppliedCoupon(null);
    setCouponFinalAmount(null);
    setCouponError('');
    setCouponSuccess('');
  };

  useEffect(() => {
    if (appliedCoupon) {
      setCouponCode('');
      resetCouponState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTicket, baseTicketPrice]);

  const handleApplyCoupon = async () => {
    const trimmedCode = couponCode.trim();
    if (!trimmedCode) {
      setCouponError('Please enter a coupon code.');
      return;
    }
    const token = localStorage.getItem('token');
    if (!isAuthenticated || !token) {
      const message = 'Please sign in to apply a coupon.';
      setCouponError(message);
      setErrorPopupMessage(message);
      setShowErrorPopup(true);
      return;
    }
    setIsApplyingCoupon(true);
    setCouponError('');
    setCouponSuccess('');
    try {
      const response = await api.validateCoupon(null, {
        code: trimmedCode,
        eventId: id,
        purchaseAmount: totalWithGst
      });
      setAppliedCoupon(response?.coupon || null);
      setCouponFinalAmount(response?.finalAmount);
      setCouponSuccess(response?.message || 'Coupon applied successfully.');
    } catch (error) {
      setAppliedCoupon(null);
      setCouponFinalAmount(null);
      setCouponError(error.message || 'Unable to apply coupon.');
    } finally {
      setIsApplyingCoupon(false);
    }
  };

  const handleRemoveCoupon = () => {
    setCouponCode('');
    resetCouponState();
  };

  const renderTicketBox = (variantClass) => {
    const radioSuffix = variantClass.includes('mobile') ? 'mobile' : 'desktop';
    return (
    <div className={`ticket-box ${variantClass}`}>
      <div className="ticket-row">
        <div className="ticket-icon">
          <img src={Ticket} alt="Female Ticket" />
        </div>
        <div className="ticket-info">
          <div className="ticket-title-row">
            <input
              className="ticket-radio"
              type="radio"
              name={`ticketType-${radioSuffix}`}
              id={`female-ticket-${radioSuffix}`}
              value="female"
              checked={selectedTicket === 'female'}
              onChange={() => setSelectedTicket('female')}
            />
            <div>
              <div className='ticket-left'>only {femaleLeftTickets} left</div>
              <div className="ticket-title">Female Ticket</div>
              <div className="ticket-subtitle">Standard ticket for 1 Female</div>
            </div>
          </div>
        </div>
        <div className="ticket-price">
          <span className="ticket-price-old">
            {typeof femalePricing.price === 'number' ? `Rs.${femalePricing.price}` : 'Rs.0'}
          </span>
          <span className="ticket-price-new">
            {typeof femalePricing.discountedPrice === 'number'
              ? `Rs.${femalePricing.discountedPrice}`
              : 'Rs.0'}
          </span>
        </div>
        <div className="ticket-badge">
          {femaleDiscountPercent !== null ? `${femaleDiscountPercent}% OFF` : 'OFF'}
        </div>
      </div>
      <div className="ticket-row">
        <div className="ticket-icon">
          <img src={Ticket} alt="Male Ticket" />
        </div>
        <div className="ticket-info">
          <div className="ticket-title-row">
            <input
              className="ticket-radio"
              type="radio"
              name={`ticketType-${radioSuffix}`}
              id={`male-ticket-${radioSuffix}`}
              value="male"
              checked={selectedTicket === 'male'}
              onChange={() => setSelectedTicket('male')}
            />
            <div>
              <div className='ticket-left'>only {maleLeftTickets} left</div>
              <div className="ticket-title">Male Ticket</div>
              <div className="ticket-subtitle">Standard ticket for 1 Male</div>
            </div>
          </div>
        </div>
        <div className="ticket-price">
          <span className="ticket-price-old">
            {typeof malePricing.price === 'number' ? `Rs.${malePricing.price}` : 'Rs.0'}
          </span>
          <span className="ticket-price-new">
            {typeof malePricing.discountedPrice === 'number'
              ? `Rs.${malePricing.discountedPrice}`
              : 'Rs.0'}
          </span>
        </div>
        <div className="ticket-badge">
          {maleDiscountPercent !== null ? `${maleDiscountPercent}% OFF` : 'OFF'}
        </div>
      </div>
      <div className="coupon-box">
        <div className="coupon-title">Got a Coupon?</div>
        <div className="coupon-row">
          <input
            type="text"
            placeholder=""
            value={couponCode}
            onChange={(event) => {
              setCouponCode(event.target.value);
              if (couponError) setCouponError('');
              if (couponSuccess) setCouponSuccess('');
              if (appliedCoupon) resetCouponState();
            }}
            disabled={isApplyingCoupon || Boolean(appliedCoupon)}
          />
          <button
            className="btn-apply"
            type="button"
            onClick={appliedCoupon ? handleRemoveCoupon : handleApplyCoupon}
            disabled={isApplyingCoupon}
          >
            {isApplyingCoupon ? 'Applying...' : appliedCoupon ? 'Remove' : 'Apply'}
          </button>
        </div>
        {couponError && <div className="coupon-error">{couponError}</div>}
        {couponSuccess && <div className="coupon-success">{couponSuccess}</div>}
      </div>

      <div className='ticketbox'>
        <div className="ticket-summary-box">
          <div className="summary-row">
            <span>Ticket:</span>
            <strong>{selectedTicket === 'female' ? 'Female Ticket' : 'Male Ticket'}</strong>
          </div>
          <div className="summary-row">
            <span>Total:</span>
            <strong>
              {`Rs.${baseTicketPrice}`}
            </strong>
          </div>
          {appliedCoupon && (
            <div className="summary-row">
              <span>Coupon Discount:</span>
              <strong>{`- Rs.${couponSavings}`}</strong>
            </div>
          )}
          {eventData?.appliedGst !== false && (
            <div className="summary-row">
              <span>Grand Total:</span>
              <strong>{`Rs.${finalPayableAmount}`}</strong>
            </div>
          )}
          <div className="summary-note">18% GST included</div>
        </div>
        <label className="terms-check">
          <input
            type="checkbox"
            checked={isTermsAccepted}
            onChange={(event) => setIsTermsAccepted(event.target.checked)}
          />
          <span>
            I accept the{' '}
            <a href="/TermsService" target="_blank" rel="noreferrer">
              Terms and Conditions
            </a>
          </span>
        </label>
        <button
          className="buy-now-btn"
          onClick={handleBuyNow}
          disabled={isCreatingOrder || !isTermsAccepted}
        >
          {isCreatingOrder ? 'Processing...' : 'Buy Now'}
        </button>

        {orderSuccess && <p className="payment-success">{orderSuccess}</p>}
      </div>
    </div>
    );
  };







  const pageTitle = eventData?.title
    ? `${eventData.title} | ${eventDateLabel} | ${eventData.city || ''}`.replace(/\s+\|\s*$/, '')
    : 'Event Details';

  return (
    <>
   
      <div className="single-event-wrapper">
        <div className="event-main-content">
          <div className="event-left">
            <img src={bannerImage} alt="Event Banner" className="banner-image" />

            <div className="about-event-box">
              <div className="about-event-title">About the event</div>
              {shouldTruncateAbout ? (
                <p className="about-desc">{aboutDisplayText}</p>
              ) : (
                <>
                  <p className="about-desc">
                    {aboutShortDescription}
                  </p>
                  {hasHtmlDescription ? (
                    <div
                      className="about-highlight"
                      dangerouslySetInnerHTML={{ __html: aboutLongDescription }}
                    />
                  ) : longDescriptionLines.length > 1 ? (
                    <ul className="about-highlight-list">
                      {longDescriptionLines.map((line, idx) => (
                        <li key={`${line}-${idx}`}>{line}</li>
                      ))}
                    </ul>
                  ) : (
                    <div className="about-highlight">{aboutLongDescription}</div>
                  )}
                </>
              )}
              {isMobile && aboutWords.length > 50 && (
                <button
                  type="button"
                  className="about-read-more"
                  onClick={() => setIsAboutExpanded((prev) => !prev)}
                >
                  {isAboutExpanded ? 'Read less' : 'Read more'}
                </button>
              )}

              <div className="event-details-row">
                <div><span>DATE:</span><strong>{eventDateLabel}</strong></div>
                <div><span>Time:</span><strong>{eventTimeLabel}</strong></div>
                <div><span>Location:</span><a href={eventData?.location} target='_blank' className='text-blue-600/100'>{eventLocationLabel}</a></div>
                <div><span>Age:</span><strong>{minage} - {maxage}</strong></div>
              </div>
            </div>

            {renderTicketBox('ticket-box--mobile')}

            <div className="expect-box">
              <div className='what-title'>What to Expect</div>
              <div className="expect-grid">
                <div className="expect-col">
                  <div className="expect-item">
                    <div className="expect-item-number">1</div>
                    <div className="expect-item-content">
                      <div className="expect-item-title">
                        A Warm, Welcoming Start
                        <div className="expect-icon">
                          <img src={sunIcon} alt="Sun icon" />
                        </div>
                      </div>
                      <div className="expect-item-desc">Arrive, settle in, and ease into the evening in a relaxed, thoughtfully chosen setting designed for comfort and conversation.</div>
                    </div>
                  </div>
                  <div className="expect-item">
                    <div className="expect-item-number">2</div>
                    <div className="expect-item-content">
                      <div className="expect-item-title">
                        Guided Yet Natural Conversations
                        <div className="expect-icon">
                          <img src={compassIcon} alt="Compass icon" />
                        </div>
                      </div>
                      <div className="expect-item-desc">Light icebreakers and gentle prompts help conversations flow — without forcing interactions or putting anyone on the spot.</div>
                    </div>
                  </div>
                  <div className="expect-item">
                    <div className="expect-item-number">3</div>
                    <div className="expect-item-content">
                      <div className="expect-item-title">
                        A Curated, Balanced Crowd
                        <div className="expect-icon">
                          <img src={groupIcon} alt="Group icon" />
                        </div>
                      </div>
                      <div className="expect-item-desc">The guest list is carefully curated to maintain balance, quality, and a comfortable atmosphere throughout the evening.</div>
                    </div>
                  </div>
                </div>
                <div className="expect-col">
                  <div className="expect-item">
                    <div className="expect-item-number">4</div>
                    <div className="expect-item-content">
                      <div className="expect-item-title">
                        Time to Mingle Freely
                        <div className="expect-icon">
                          <img src={peopleIcon} alt="People icon" />
                        </div>
                      </div>
                      <div className="expect-item-desc">After the guided flow, enjoy unstructured time to continue conversations, meet new people, or simply take in the vibe.</div>
                    </div>
                  </div>
                  <div className="expect-item">
                    <div className="expect-item-number">5</div>
                    <div className="expect-item-content">
                      <div className="expect-item-title">
                        An Experience Without Pressure
                        <div className="expect-icon">
                          <img src={leafIcon} alt="Leaf icon" />
                        </div>
                      </div>
                      <div className="expect-item-desc">No expectations, no outcomes to chase. Just an evening designed to be enjoyed — however it unfolds for you.</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="attending-box">
              <div className="about-event-title">Who is attending ?</div>
              <div className="attendee-list">
                <div className="attendee-columns">
                  {attendeesToShow.length <= 1 ? (
                    <div className="attendee-column">
                      {attendeesToShow.map((item) => (
                        <div className="attendee-card" key={item.image}>
                          <img src={item.image} alt={item.name} className="attendee-img" />
                          <div className="attendee-name">{item.name}</div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    [0, 1, 2].map((col) => {
                      const rotatedItems = attendeesToShow
                        .slice(col)
                        .concat(attendeesToShow.slice(0, col));
                      const loopItems = rotatedItems.concat(rotatedItems);
                      return (
                        <div className="attendee-column" key={`col-${col}`}>
                          <div className={`attendee-track track-${col + 1}`}>
                            {loopItems.map((item, idx) => (
                              <div
                                className="attendee-card"
                                key={`${item.image}-${idx}-${col}`}
                                aria-hidden={idx >= rotatedItems.length}
                              >
                                <img src={item.image} alt={item.name} className="attendee-img" />
                                <div className="attendee-name">{item.name}</div>
                              </div>
                            ))}
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            </div>
            {/* Review box */}
            <div className="review-box">
              <Reviews showSidebarTitle={false} showBackground={false} showButton={false} />
            </div>
          </div>

          <div className="event-right">
            {renderTicketBox('ticket-box--desktop')}
          </div>
        </div>
      </div>

      <Subscribe />
      {showGuestForm && (
        <div className="guest-modal-overlay" onClick={() => setShowGuestForm(false)}>
          <div className="guest-modal" onClick={(event) => event.stopPropagation()}>
            <h3>Enter your details</h3>
            <p>We need a few details to reserve your ticket.</p>
            <form className="guest-form" onSubmit={handleGuestSubmit}>
              <label>
                Full Name
                <input
                  type="text"
                  name="fullName"
                  value={guestData.fullName}
                  onChange={handleGuestInputChange}
                  placeholder="Enter your full name"
                />
              </label>
              <label>
                Email
                <input
                  type="email"
                  name="email"
                  value={guestData.email}
                  onChange={handleGuestInputChange}
                  placeholder="Enter your email"
                />
              </label>
              <label>
                Phone
                <input
                  type="tel"
                  name="phone"
                  value={guestData.phone}
                  onChange={handleGuestInputChange}
                  placeholder="Enter your phone number"
                  inputMode="numeric"
                  pattern="[0-9]{10}"
                  maxLength={10}
                />
              </label>
              <div className="guest-actions">
                <button type="button" className="guest-cancel" onClick={() => setShowGuestForm(false)}>
                  Cancel
                </button>
                <button type="submit" className="guest-submit" disabled={isCreatingOrder}>
                  {isCreatingOrder ? 'Processing...' : 'Continue to Pay'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {showErrorPopup && (
        <div className="error-modal-overlay" onClick={() => setShowErrorPopup(false)}>
          <div className="error-modal" onClick={(event) => event.stopPropagation()}>
            <h3>Unable to proceed</h3>
            <p>{errorPopupMessage}</p>
            <button type="button" className="error-ok" onClick={() => setShowErrorPopup(false)}>
              OK
            </button>
          </div>
        </div>
      )}
       {/* <Helmet>
        <title>{pageTitle}</title>
    </Helmet> */}
    </>
  );
};

export default Singleeventdetails;
